exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".member-photo {\r\n\t-o-object-fit: cover;\r\n\t   object-fit: cover;\r\n\theight: 110px;\r\n\twidth: 100px;\r\n\tborder-radius: 5px;\r\n\tmargin-top: 6%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/team-member-directory/team-member-directory.component.css
// module id = 572
// module chunks = 1